import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a71c5f14&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a71c5f14')) {
      api.createRecord('a71c5f14', component.options)
    } else {
      api.reload('a71c5f14', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a71c5f14&", function () {
      api.rerender('a71c5f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2776JM2YTu8JG/JS/comp/ImgFallback.vue"
export default component.exports